import { render, staticRenderFns } from "./ButtonWithFeedback.vue?vue&type=template&id=13161b6c&scoped=true"
import script from "./ButtonWithFeedback.vue?vue&type=script&lang=js"
export * from "./ButtonWithFeedback.vue?vue&type=script&lang=js"
import style0 from "./ButtonWithFeedback.vue?vue&type=style&index=0&id=13161b6c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13161b6c",
  null
  
)

export default component.exports